import { render } from "./PanelAgendaPanelistEdit.vue?vue&type=template&id=00b9b538"
import script from "./PanelAgendaPanelistEdit.vue?vue&type=script&lang=js"
export * from "./PanelAgendaPanelistEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__